import AppFixed from '../../mixins/app-fixed'

import AppBtnSkew from '../app-btn-skew'
import AppHsmLink from '../app-hsm-link'

// URL list
import URL from '../../../config.url'


// hsm = home sticky menu
export default
{
    name: 'app-hsm',

    mixins:
    [
        AppFixed
    ],

    components:
    {
        AppBtnSkew,
        AppHsmLink
    },

    props:
    {
        content: { type: Object,
            default: () =>
            {

            }
        },
        state: { type: Number, default: -1 },
        games: { type: Array, default: () => [] }
    },

    data()
    {
        return {
            pageUrl: URL.page,
            isHover: -1,
            currentSelect: -1
        }
    },

    watch:
    {
        state: '_changeCurrentHover'
    },

    created()
    {
        // for (let i = 0, l = this.games.length; i < l; i += 1)
        // {
        //     if (this.games[i].informations.logo_light)
        //     {
        //         const image = new Image()

        //         image.onload = () =>
        //         {
        //             this.games[i].informations.logo_light_width = image.width
        //             this.games[i].informations.logo_light_height = image.height
        //         }
        //         image.src = this.games[i].informations.logo_light
        //     }
        // }
    },

    methods:
    {
        _onClickMessage()
        {
            if (this.state < 0)
            {
                this.$root.scrollTo(this.$root.height)
            }
            else
            {
                this.$root.scrollTo(0)
            }
        },

        _changeCurrentHover()
        {
            this.currentSelect = this.isHover > -1 ? this.isHover : this.state
        },

        _onOutGames()
        {
            this.isHover = -1
            this.$emit('outgames')
            this.eventHub.$emit('outgames')
            this._changeCurrentHover()
        },

        _onOverGame(num)
        {
            this.isHover = num
            this.$emit('overgame', num)
            this.eventHub.$emit('overgame', num)
            this._changeCurrentHover()
        },

        _getLogoHeight(game)
        {
            const image = new Image()

            image.onload = () => 80 * image.height * image.width
            image.src = game.informations.logo_light
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-hsm/script.js